import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import Axios from "axios";


Vue.prototype.Axios=Axios;
//Axios.defaults.baseURL=`http://gq.2345pro.com`;
Axios.defaults.baseURL=`/api`;
Axios.defaults.headers={
  'content-type':'application/x-www-form-urlencoded'
}


Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
